var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('no-internet-connection'),_c('notification-loader'),_c('notification-info'),_c('error'),_c('notification-groups'),_c('expired-session'),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }